import {
    primaryColor,
    warningColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    transition,
    primaryBoxShadow,
    infoBoxShadow,
    successBoxShadow,
    warningBoxShadow,
    dangerBoxShadow,
    roseBoxShadow,
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    roseCardHeader,
} from "assets/jss/material-dashboard-pro-react.jsx";
const fileBlockStyle = {
    fileBlockImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        borderRadius: 3,
        zIndex: 0,
        "&:before": {
            content: '""',
            backgroundColor: '#000',
            opacity: 0.5,
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: 3,
        }
    },
    fileBlockContainer: {
        height: 100,
        width: 100,
        color: '#fff',
        borderRadius: 3,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflow: 'hidden',
        margin: 4,
        "&.rose": roseCardHeader,
        "&.primary": primaryCardHeader,
        "&.info": infoCardHeader,
        "&.danger": dangerCardHeader,
        "&.success": successCardHeader,
        "&.warning": warningCardHeader,
    },
    folderBlockContainer: {
        ...transition,
        height: 100,
        width: 100,
        borderRadius: 3,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflow: 'hidden',
        margin: 4,
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: '#ffffff',
        "&:hover": {
            ...transition,
            "&.rose": {
                backgroundColor: roseColor,
                color: '#ffffff'
            },
            "&.primary": {
                backgroundColor: primaryColor,
                color: '#ffffff'
            },
            "&.info": {
                backgroundColor: infoColor,
                color: '#ffffff'
            },
            "&.danger": {
                backgroundColor: dangerColor,
                color: '#ffffff'
            },
            "&.success": {
                backgroundColor: successColor,
                color: '#ffffff'
            },
            "&.warning": {
                backgroundColor: warningColor,
                color: '#ffffff'
            },
        },
        "&.rose": {
            ...roseBoxShadow,
            color: roseColor,
            borderColor: roseColor
        },
        "&.primary": {
            ...primaryBoxShadow,
            color: primaryColor,
            borderColor: primaryColor
        },
        "&.info": {
            ...infoBoxShadow,
            color: infoColor,
            borderColor: infoColor
        },
        "&.danger": {
            ...dangerBoxShadow,
            color: dangerColor,
            borderColor: dangerColor
        },
        "&.success": {
            ...successBoxShadow,
            color: successColor,
            borderColor: successColor
        },
        "&.warning": {
            ...warningBoxShadow,
            color: warningColor,
            borderColor: warningColor
        },
    },
    fileBlockClickable: {
        cursor: 'pointer'
    },
    fileName: {
        textOverflow: 'ellipsis',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textAlign: 'left',
        width: 100,
        fontSize: '12px',
        zIndex: 1,
        padding: 10
    },
    fileIcon: {
        flex: 1,
        zIndex: 1,
        margin: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 80
    }
};

export default fileBlockStyle;